<template>
  <div class="resetPasswordView">
    <!-- <appHeaderMini></appHeaderMini> -->
    <div class="container">
      <div class="main">
        <form class="resetForm">
          <h4 class="bigTitle">
            重新设置密码
            <i class="underscore"></i>
          </h4>
          <FormInput
            class="mt-5"
            :maxlength="form.country_id==44 ? 11 : 30"
            v-model="form.key"
            autocomplete="username"
            label="手机号码或邮箱"
            placeholder="请输入手机号或邮箱"
            :readonly="phoneReadonly"
            :isShowPrefix="true"
            @changeCountry="changeCountry"
            @changeDeafultCountry="changeDeafultCountry"
          ></FormInput>
          <!-- <FormSMSInput class="mt-5" :maxlength="6" :type="2" :from="'resetPassword'" v-model="form.code" @status-change="handleSMSChange" :telephone="form.key" label="验证码" placeholder="请输入验证码"></FormSMSInput> -->
          <FormSMSInput
            class="mt-5"
            :maxlength="6"
            :type="2"
            :from="'resetPassword'"
            v-model="form.code"
            @status-change="handleSMSChange"
            :telephone="form.key"
            label="验证码"
            placeholder="请输入验证码"
            :isCaptcha="false"
            ref="smsInput"
            @captcha="handleCaptcha"

          ></FormSMSInput>
          <FormInput
            :type="passwordType"
            :showEye="true"
            :minlength="8"
            :maxlength="20"
            autocomplete="new-password"
            class="mt-5"
            v-model="form.password"
            @viewPassword="viewPassword"
            label="设置新密码"
            placeholder="密码必须包含字母和数字，长度8-20位"
          ></FormInput>
          <FormButton width="100%" mt="50px" @click="handleSubmit" :disabled="!isFormValid">确认</FormButton>
          <FormButton inline theme="normal" width="100%" mt="10px" @click="handleLogout">返回</FormButton>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import authApi from '@/services/auth/index'
import { mapGetters } from 'vuex'
import { validForm, validTelephone, validPassword } from '@/utils/validators'
import sendSensors from '@/mixins/sendSensors.js'
import { getCountryNameZh } from '@/utils/index'

export default {
  mixins: [sendSensors],
  data () {
    return {
      smsDirty: false,
      phoneReadonly: false,
      form: {
        key: '',
        code: '',
        password: '',
        country_id: 44
      },
      passwordType: 'password'
    }
  },
  computed: {
    ...mapGetters(['workCountryData']),
    isFormValid () {
      return this.smsDirty && validForm(this.form)
    }
  },
  methods: {
    handleCaptcha (params) {
      if (!validTelephone(this.form.key)) {
        return this.$toast.warning('手机号不合法')
      }
    },
    handleTimeDown () {
      this.$refs.smsInput.startCountdown()
    },
    handleSMSChange () {
      this.smsDirty = true
    },
    handleLogout () {
      history.back()
    },
    async handleSubmit () {
      if (!validTelephone(this.form.key)) {
        return this.$toast.warning('手机号不合法')
      }
      if (!this.form.code || (this.form.code && this.form.code.length !== 6)) {
        return this.$toast.warning('验证码不合法')
      }
      if (!validPassword(this.form.password)) {
        return this.$toast.warning('密码不合法')
      }

      authApi.resetPassword(this.form).then(res => {
        if (res.ok) {
          this.$router.push('/stu/stulogin')
        }
      })
    },
    viewPassword () {
      if (this.passwordType === 'text') {
        this.passwordType = 'password'
      } else {
        this.passwordType = 'text'
      }
    },
    changeCountry (val) {
      this.form.country_id = val
      let nameZh = getCountryNameZh(this.workCountryData, this.form.country_id)
      this.sendSensors('Abroad_number', { 'Forget_password': nameZh })
    },
    // 修改默认区号
    changeDeafultCountry (val) {
      this.form.country_id = val
    }
  },
  created () {
    this.form.key = ''
  }
}
</script>

<style scoped lang="scss">
  .resetPasswordView {
    position: relative;
    width: 100%;
    min-height: 79vh;
    padding-top: 0;
    z-index: 10;
    /deep/ .phone-prefix-select {
      height: 34px;
      width: 80px;
    }
    /deep/ .el-input--suffix {
      height: 100%;
    }
    /deep/ .el-select-dropdown {
      width: 380px!important;
    }
  }

  .main {
    width: 1000px;
    min-width: 600px;
    min-height: 504px;
    margin: 10vh auto;
    padding: 58px 0;
    background-color: #fff;
    @include panel-rounded;
    @include panel-blur;
    .resetForm {
      width: 340px;
      margin: 0 auto;
      .bigTitle {
        position: relative;
        font-size: 28px;
        text-align: left;
        .underscore {
          position: absolute;
          left: 0;
          top: 40px;
          display: inline-block;
          width: 32px;
          height: 4px;
          background: #ffd200;
          border-radius: 2px;
        }
      }
      /deep/ .pl85 {
        // padding-left: 80px;
      }
    }
  }
</style>
